import { render } from "./TaskWordPairRecall.vue?vue&type=template&id=94244e6e"
import script from "./TaskWordPairRecall.vue?vue&type=script&lang=js"
export * from "./TaskWordPairRecall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__